<template>
  <div class="container">
    <div class="columns">
      <div class="column has-text-left">
        <div class="columns is-mobile">
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-right" :label="$translate('copy_dx_in_sx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copyLiningMeasurementsToLeft()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('left_foot') | uppercase }}
            </h3>
          </div>
        </div>
      </div>
      <div class="column has-text-right">
        <div class="columns is-mobile">
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('right_foot') | uppercase }}
            </h3>
          </div>
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copyLiningMeasurementsToRight()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div style="position: relative">
          <img
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Base_SX.png"
          />
          <img
            v-if="order.imb_gamb_sx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Gambetti_SX.png"
          />
          <img
            v-if="order.imb_gamb_sx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Linguetta_BASE_SX.png"
          />
          <img
            v-if="order.ling_sx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Linguetta_SX.png"
          />
          <img
            v-if="order.malllat_sx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Malleolo_LAT_SX.png"
          />
          <img
            v-if="order.mallmed_sx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Malleolo_MED_SX.png"
          />
          <img
            v-if="order.masch_sx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Mascherina_SX.png"
          />
          <img
            v-if="order.termtom_sx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Toppone_SX.png"
          />
        </div>
      </div>
      <div class="column is-6">
        <table class="bordered-table static">
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('imbott') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <hr class="green" />
            </td>
            <td />
          </tr>
          <tr
            v-for="elem in [
              { key: 'masch' },
              { key: 'ling' },
              { key: 'mallmed' },
              { key: 'malllat' },
              { key: 'termtom' },
              { key: 'imb_gamb' },
            ]"
            :key="elem.key"
          >
            <td>
              <b-input
                v-model="order[elem.key + '_sx']"
                type="number"
                :placeholder="$translate('placeholder_numeric_lining')"
                :disabled="order.pair === 'right' || disabledbool"
              />
            </td>
            <td>
              {{ $translate(elem.key) | capitalize }}
            </td>
            <td>
              <b-input
                v-model="order[elem.key + '_dx']"
                type="number"
                :placeholder="$translate('placeholder_numeric_lining')"
                :disabled="order.pair === 'left' || disabledbool"
              />
            </td>
          </tr>
        </table>
      </div>
      <div class="column">
        <div style="position: relative">
          <img
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Base_DX.png"
          />
          <img
            v-if="order.imb_gamb_dx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Gambetti_DX.png"
          />
          <img
            v-if="order.imb_gamb_dx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Linguetta_BASE_DX.png"
          />
          <img
            v-if="order.ling_dx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Linguetta_DX.png"
          />
          <img
            v-if="order.malllat_dx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Malleolo_LAT_DX.png"
          />
          <img
            v-if="order.mallmed_dx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Malleolo_MED_DX.png"
          />
          <img
            v-if="order.masch_dx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Mascherina_DX.png"
          />
          <img
            v-if="order.termtom_dx > 0"
            style="position: absolute; top: 100px; bottom: 0; left: 0; right: 0"
            src="@/assets/images/imbottiture/Toppone_DX.png"
          />
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column has-text-left">
        <div class="columns is-mobile">
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-right" :label="$translate('copy_dx_in_sx') | capitalize" multilined>
              <a class="button is-primary" :disabled="order.pair !== 'both' || disabledbool" @click="copypasdxinsx()">
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('left_foot') | uppercase }}
            </h3>
          </div>
        </div>
      </div>
      <div class="column has-text-right">
        <div class="columns is-mobile">
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('right_foot') | uppercase }}
            </h3>
          </div>
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
              <a class="button is-primary" :disabled="order.pair !== 'both' || disabledbool" @click="copypassxindx()">
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <img class="preview" :src="contrSxPreview" />
      </div>
      <div class="column is-6">
        <table class="bordered-table static">
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('PaS') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <hr class="green" />
            </td>
            <td />
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('typecontr_sx') }" :message="errors.first('typecontr_sx')">
                <b-select
                  v-model="order['typecontr_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  name="typecontr_sx"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option v-for="(t, i) in contrType" :key="i" :value="t">{{ $translate(t) | capitalize }}</option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('type') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('typecontr_dx') }" :message="errors.first('typecontr_dx')">
                <b-select
                  v-model="order['typecontr_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'typecontr_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option v-for="(t, i) in contrType" :key="i" :value="t">{{ $translate(t) | capitalize }}</option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_sx') }"
                :message="errors.first('tipocontr_sx')"
              >
                <b-select
                  v-model="order['tipocontr_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tipocontr_sx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="changeContrMaterialSx"
                >
                  <option v-for="variant in availablecont" :key="variant.id + '_sx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('matcontra') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-field
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_dx') }"
                :message="errors.first('tipocontr_dx')"
              >
                <b-select
                  v-model="order['tipocontr_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tipocontr_dx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="order['tipocontr_var_dx'] = null"
                >
                  <option v-for="variant in availablecont" :key="variant.id + '_dx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td
              v-if="
                order['tipocontr_sx'] &&
                  availablecont.find(temp => temp.id === order['tipocontr_sx']) &&
                  availablecont.find(temp => temp.id === order['tipocontr_sx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_var_sx') }"
                :message="errors.first('tipocontr_var_sx')"
              >
                <b-select
                  v-model="order['tipocontr_var_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tipocontr_var_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablecont.find(temp => temp.id === order['tipocontr_sx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['tipocontr_dx']" class="has-text-centered" />
            <td v-if="order['tipocontr_sx'] || order['tipocontr_dx']" class="has-text-centered">
              {{ $translate('variant') | capitalize }}
            </td>
            <td
              v-if="
                order['tipocontr_dx'] &&
                  availablecont.find(temp => temp.id === order['tipocontr_dx']) &&
                  availablecont.find(temp => temp.id === order['tipocontr_dx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_var_dx') }"
                :message="errors.first('tipocontr_var_dx')"
              >
                <b-select
                  v-model="order['tipocontr_var_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tipocontr_var_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablecont.find(temp => temp.id === order['tipocontr_dx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['tipocontr_sx']" class="has-text-centered" />
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-select
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                v-model="order['tiporinfcontr_sx']"
                :disabled="order.pair === 'right' || disabledbool"
                :name="'tiporinfcontr_sx'"
                :placeholder="$translate('placeholder_select')"
                @input="
                  order['matrinfcontr_sx'] = null
                  order['matrinfcontr_var_sx'] = null
                  $forceUpdate()
                "
              >
                <option value="Noone">
                  {{ $translate('Noone') | capitalize }}
                </option>
                <option value="total">
                  {{ $translate('total') | capitalize }}
                </option>
                <option value="only_base">
                  {{ $translate('only_base') | capitalize }}
                </option>
                <option value="only_post">
                  {{ $translate('only_post') | capitalize }}
                </option>
              </b-select>
            </td>
            <td class="has-text-centered">
              {{ $translate('rinfcontr') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-select
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                v-model="order['tiporinfcontr_dx']"
                :disabled="order.pair === 'left' || disabledbool"
                :name="'tiporinfcontr_dx'"
                :placeholder="$translate('placeholder_select')"
                @input="
                  order['matrinfcontr_dx'] = null
                  order['matrinfcontr_var_dx'] = null
                  $forceUpdate()
                "
              >
                <option value="Noone">
                  {{ $translate('Noone') | capitalize }}
                </option>
                <option value="total">
                  {{ $translate('total') | capitalize }}
                </option>
                <option value="only_base">
                  {{ $translate('only_base') | capitalize }}
                </option>
                <option value="only_post">
                  {{ $translate('only_post') | capitalize }}
                </option>
              </b-select>
            </td>
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-select
                v-if="order['tiporinfcontr_sx'] && order['tiporinfcontr_sx'] != 'Noone'"
                v-model="order['matrinfcontr_sx']"
                :disabled="order.pair === 'right' || disabledbool"
                :name="'matrinfcontr_sx'"
                :placeholder="$translate('placeholder_select')"
                @input="
                  order['matrinfcontr_var_sx'] = null
                  $forceUpdate()
                "
              >
                <option v-for="variant in availablereinforcement" :key="variant.id + '_sx'" :value="variant.id">
                  {{ $translateMaterial(variant) }}
                </option>
              </b-select>
            </td>
            <td class="has-text-centered">
              {{ $translate('matrinfcontr') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-select
                v-if="order['tiporinfcontr_dx'] && order['tiporinfcontr_dx'] != 'Noone'"
                v-model="order['matrinfcontr_dx']"
                :disabled="order.pair === 'left' || disabledbool"
                :name="'matrinfcontr_dx'"
                :placeholder="$translate('placeholder_select')"
                @input="
                  order['matrinfcontr_var_dx'] = null
                  $forceUpdate()
                "
              >
                <option v-for="variant in availablereinforcement" :key="variant.id + '_dx'" :value="variant.id">
                  {{ $translateMaterial(variant) }}
                </option>
              </b-select>
            </td>
          </tr>
          <tr>
            <td
              v-if="
                order['matrinfcontr_sx'] &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_sx']) &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_sx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('matrinfcontr_var_sx') }"
                :message="errors.first('matrinfcontr_var_sx')"
              >
                <b-select
                  v-model="order['matrinfcontr_var_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'matrinfcontr_var_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablereinforcement.find(temp => temp.id === order['matrinfcontr_sx'])
                      .variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['matrinfcontr_dx']" class="has-text-centered" />
            <td v-if="order['matrinfcontr_sx'] || order['matrinfcontr_dx']" class="has-text-centered">
              {{ $translate('variant') | capitalize }}
            </td>
            <td
              v-if="
                order['matrinfcontr_dx'] &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_dx']) &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_dx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('matrinfcontr_var_dx') }"
                :message="errors.first('matrinfcontr_var_dx')"
              >
                <b-select
                  v-model="order['matrinfcontr_var_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'matrinfcontr_var_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablereinforcement.find(temp => temp.id === order['matrinfcontr_dx'])
                      .variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
        </table>
      </div>
      <div class="column has-text-right">
        <img class="preview" :src="contrDxPreview" />
      </div>
    </div>
    <!-- Sezione Puntali -->
    <div class="columns">
      <div class="column has-text-left">
        <div class="columns is-mobile">
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-right" :label="$translate('copy_dx_in_sx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copypuntalidxinsx()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('left_foot') | uppercase }}
            </h3>
          </div>
        </div>
      </div>
      <div class="column has-text-right">
        <div class="columns is-mobile">
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('right_foot') | uppercase }}
            </h3>
          </div>
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copypuntalisxindx()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <img
          v-if="order['tipopunt_sx'] == 'tipopunt1' || order['tipopunt_sx'] == null"
          src="https://via.placeholder.com/150"
          style="max-height: 183px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_sx'] == 'tipopunt2'"
          src="@/assets/images/puntali/standard_sx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_sx'] == 'tipopunt3'"
          src="@/assets/images/puntali/a_giro_sx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_sx'] == 'tipopunt4'"
          src="@/assets/images/puntali/corto_sx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_sx'] == 'tipopunt5'"
          src="@/assets/images/puntali/prol_mediale_sx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_sx'] == 'tipopunt6'"
          src="@/assets/images/puntali/prol_laterale_sx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_sx'] == 'tipopunt7'"
          src="@/assets/images/puntali/sopra_le_dita_sx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <br />
        <img
          v-if="
            availablepunt &&
              availablepunt.find(temp => temp.id === order['tipopunt_mat_sx']) &&
              order['tipopunt_mat_var_sx'] != null
          "
          :src="
            availablepunt
              .find(temp => temp.id == order['tipopunt_mat_sx'])
              .variants.find(temp => temp.id == order['tipopunt_mat_var_sx']).image
          "
          style="max-width: 150px; max-height: 150px; display: none"
        />
        <img v-else src="https://via.placeholder.com/150" style="max-width: 150px; max-height: 150px; display: none" />
      </div>
      <div class="column is-6">
        <table class="bordered-table static">
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('puntali') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <hr class="green" />
            </td>
            <td />
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('tipopunt_sx') }" :message="errors.first('tipopunt_sx')">
                <b-select
                  v-model="order['tipopunt_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tipopunt_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option value="tipopunt1">
                    {{ $translate('tipopunt1') }}
                  </option>
                  <option value="tipopunt2">
                    {{ $translate('tipopunt2') }}
                  </option>
                  <option value="tipopunt3">
                    {{ $translate('tipopunt3') }}
                  </option>
                  <option value="tipopunt4">
                    {{ $translate('tipopunt4') }}
                  </option>
                  <option value="tipopunt5">
                    {{ $translate('tipopunt5') }}
                  </option>
                  <option value="tipopunt6">
                    {{ $translate('tipopunt6') }}
                  </option>
                  <option value="tipopunt7">
                    {{ $translate('tipopunt7') }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('tipopunt') }}
            </td>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('tipopunt_dx') }" :message="errors.first('tipopunt_dx')">
                <b-select
                  v-model="order['tipopunt_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  name="tipopunt_dx"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option value="tipopunt1">
                    {{ $translate('tipopunt1') }}
                  </option>
                  <option value="tipopunt2">
                    {{ $translate('tipopunt2') }}
                  </option>
                  <option value="tipopunt3">
                    {{ $translate('tipopunt3') }}
                  </option>
                  <option value="tipopunt4">
                    {{ $translate('tipopunt4') }}
                  </option>
                  <option value="tipopunt5">
                    {{ $translate('tipopunt5') }}
                  </option>
                  <option value="tipopunt6">
                    {{ $translate('tipopunt6') }}
                  </option>
                  <option value="tipopunt7">
                    {{ $translate('tipopunt7') }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field
                :type="{ 'is-danger': errors.has('tipopunt_mat_sx') }"
                :message="errors.first('tipopunt_mat_sx')"
              >
                <b-select
                  v-if="order['tipopunt_sx'] && order['tipopunt_sx'] != 'tipopunt1'"
                  v-model="order['tipopunt_mat_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tipopunt_mat_sx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="
                    order['tipopunt_mat_var_sx'] = null
                    $forceUpdate()
                  "
                >
                  <option v-for="variant in availablepunt" :key="variant.id + '_sx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('puntalemat') }}
            </td>
            <td class="has-text-centered">
              <b-field
                :type="{ 'is-danger': errors.has('tipopunt_mat_dx') }"
                :message="errors.first('tipopunt_mat_dx')"
              >
                <b-select
                  v-if="order['tipopunt_dx'] && order['tipopunt_dx'] != 'tipopunt1'"
                  v-model="order['tipopunt_mat_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tipopunt_mat_dx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="
                    order['tipopunt_mat_var_dx'] = null
                    $forceUpdate()
                  "
                >
                  <option v-for="variant in availablepunt" :key="variant.id + '_dx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td
              v-if="
                order['tipopunt_mat_sx'] &&
                  availablepunt.find(temp => temp.id === order['tipopunt_mat_sx']) &&
                  availablepunt.find(temp => temp.id === order['tipopunt_mat_sx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                :type="{ 'is-danger': errors.has('tipopunt_mat_var_sx') }"
                :message="errors.first('tipopunt_mat_var_sx')"
              >
                <b-select
                  v-if="order['tipopunt_sx'] && order['tipopunt_sx'] != 'tipopunt1'"
                  v-model="order['tipopunt_mat_var_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tipopunt_mat_var_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablepunt.find(temp => temp.id === order['tipopunt_mat_sx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['tipopunt_mat_dx']" class="column is-4 has-text-centered" />
            <td v-if="order['tipopunt_mat_sx'] || order['tipopunt_mat_dx']" class="has-text-centered">
              {{ $translate('variant') | capitalize }}
            </td>
            <td
              v-if="
                order['tipopunt_mat_dx'] &&
                  availablepunt.find(temp => temp.id === order['tipopunt_mat_dx']) &&
                  availablepunt.find(temp => temp.id === order['tipopunt_mat_dx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                :type="{ 'is-danger': errors.has('tipopunt_mat_var_dx') }"
                :message="errors.first('tipopunt_mat_var_dx')"
              >
                <b-select
                  v-if="order['tipopunt_dx'] && order['tipopunt_dx'] != 'tipopunt1'"
                  v-model="order['tipopunt_mat_var_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tipopunt_mat_var_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablepunt.find(temp => temp.id === order['tipopunt_mat_dx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
        </table>
      </div>
      <div class="column has-text-right">
        <img
          v-if="order['tipopunt_dx'] == 'tipopunt1' || order['tipopunt_dx'] == null"
          src="https://via.placeholder.com/150"
          style="max-height: 183px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_dx'] == 'tipopunt2'"
          src="@/assets/images/puntali/standard_dx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_dx'] == 'tipopunt3'"
          src="@/assets/images/puntali/a_giro_dx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_dx'] == 'tipopunt4'"
          src="@/assets/images/puntali/corto_dx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_dx'] == 'tipopunt5'"
          src="@/assets/images/puntali/prol_mediale_dx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_dx'] == 'tipopunt6'"
          src="@/assets/images/puntali/prol_laterale_dx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <img
          v-else-if="order['tipopunt_dx'] == 'tipopunt7'"
          src="@/assets/images/puntali/sopra_le_dita_dx.png"
          style="max-height: 300px; max-width: 300px; width: 300px"
        />
        <br />
        <img
          v-if="
            availablepunt &&
              availablepunt.find(temp => temp.id === order['tipopunt_mat_dx']) &&
              order['tipopunt_mat_var_dx'] != null
          "
          :src="
            availablepunt
              .find(temp => temp.id == order['tipopunt_mat_dx'])
              .variants.find(temp => temp.id == order['tipopunt_mat_var_dx']).image
          "
          style="max-width: 150px; max-height: 150px; display: none"
        />
        <img v-else src="https://via.placeholder.com/150" style="max-width: 150px; max-height: 150px; display: none" />
      </div>
    </div>
    <!-- Sezione sottopiede -->

    <div class="columns">
      <div class="column has-text-left">
        <div class="columns is-mobile">
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-right" :label="$translate('copy_dx_in_sx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copysottopiededxinsx()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('left_foot') | uppercase }}
            </h3>
          </div>
        </div>
      </div>
      <div class="column has-text-right">
        <div class="columns is-mobile">
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('right_foot') | uppercase }}
            </h3>
          </div>
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copysottopiedesxindx()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column" />
      <div class="column is-6">
        <table class="bordered-table static">
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('sottopiede') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <hr class="green" />
            </td>
            <td />
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('tiposott_sx') }" :message="errors.first('tiposott_sx')">
                <b-select
                  v-model="order['tiposott_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tiposott_sx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="order['tiposott_var_sx'] = null"
                >
                  <option v-for="variant in availablesott" :key="variant.id + '_sx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('matsotto') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('tiposott_dx') }" :message="errors.first('tiposott_dx')">
                <b-select
                  v-model="order['tiposott_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tiposott_dx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="order['tiposott_var_dx'] = null"
                >
                  <option v-for="variant in availablesott" :key="variant.id + '_dx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td
              v-if="
                order['tiposott_sx'] &&
                  availablesott.find(temp => temp.id === order['tiposott_sx']) &&
                  availablesott.find(temp => temp.id === order['tiposott_sx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                :type="{ 'is-danger': errors.has('tiposott_var_sx') }"
                :message="errors.first('tiposott_var_sx')"
              >
                <b-select
                  v-model="order['tiposott_var_sx']"
                  v-validate="{ required: order.pair !== 'right' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tiposott_var_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablesott.find(temp => temp.id === order['tiposott_sx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['tiposott_dx']" class="has-text-centered" />
            <td v-if="order['tiposott_sx'] || order['tiposott_dx']" class="has-text-centered">
              {{ $translate('variant') | capitalize }}
            </td>
            <td
              v-if="
                order['tiposott_dx'] &&
                  availablesott.find(temp => temp.id === order['tiposott_dx']) &&
                  availablesott.find(temp => temp.id === order['tiposott_dx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                :type="{ 'is-danger': errors.has('tiposott_var_dx') }"
                :message="errors.first('tiposott_var_dx')"
              >
                <b-select
                  v-model="order['tiposott_var_dx']"
                  v-validate="{ required: order.pair !== 'left' && order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tiposott_var_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablesott.find(temp => temp.id === order['tiposott_dx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-select
                v-model="order['tiporinfsott_sx']"
                :disabled="order.pair === 'right' || disabledbool"
                :name="'tiporinfsott_sx'"
                :placeholder="$translate('placeholder_select')"
                @input="warningSottopiedeRinforzo('sx')"
              >
                <option value="sottopiede3">
                  {{ $translate('sottopiede3') }}
                </option>
                <option value="sottopiede4">
                  {{ $translate('sottopiede4') }}
                </option>
                <option value="sottopiede5">
                  {{ $translate('sottopiede5') }}
                </option>
                <option value="sottopiede6">
                  {{ $translate('sottopiede6') }}
                </option>
                <option value="sottopiede7">
                  {{ $translate('sottopiede7') }}
                </option>
              </b-select>
            </td>
            <td class="has-text-centered">
              {{ $translate('typesott') }}
            </td>
            <td class="has-text-centered">
              <b-select
                v-model="order['tiporinfsott_dx']"
                :disabled="order.pair === 'left' || disabledbool"
                :name="'tiporinfsott_dx'"
                :placeholder="$translate('placeholder_select')"
                @input="warningSottopiedeRinforzo('dx')"
              >
                <option value="sottopiede3">
                  {{ $translate('sottopiede3') }}
                </option>
                <option value="sottopiede4">
                  {{ $translate('sottopiede4') }}
                </option>
                <option value="sottopiede5">
                  {{ $translate('sottopiede5') }}
                </option>
                <option value="sottopiede6">
                  {{ $translate('sottopiede6') }}
                </option>
                <option value="sottopiede7">
                  {{ $translate('sottopiede7') }}
                </option>
              </b-select>
            </td>
          </tr>
        </table>

        <br /><br />
        <table class="bordered-table static">
          <tr>
            <td></td>
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('sol_vant') | uppercase }}
              </h3>
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>
              <hr class="green" />
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b-input
                v-model="order.footmeasurements.thick_plant_sx"
                type="number"
                step="1"
                :disabled="order.pair === 'right' || disabledbool"
                :placeholder="$translate('placeholder_numeric_mm')"
              />
            </td>
            <td>
              {{ $translate('thick_pla') }}
            </td>
            <td>
              <b-input
                v-model="order.footmeasurements.thick_plant_dx"
                type="number"
                step="1"
                :disabled="order.pair === 'left' || disabledbool"
                :placeholder="$translate('placeholder_numeric_mm')"
              />
            </td>
          </tr>

          <tr>
            <td>
              <b-input
                v-model="order.footmeasurements.thick_tacc_sx"
                type="number"
                step="1"
                :disabled="order.pair === 'right' || disabledbool"
                :placeholder="$translate('placeholder_numeric_mm')"
              />
            </td>
            <td>
              {{ $translate('thick_tacc') }}
            </td>
            <td>
              <b-input
                v-model="order.footmeasurements.thick_tacc_dx"
                type="number"
                step="1"
                :disabled="order.pair === 'left' || disabledbool"
                :placeholder="$translate('placeholder_numeric_mm')"
              />
            </td>
          </tr>
        </table>

        <!--<b-collapse class="card" aria-id="contentIdsol_vant" :open="false">
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
            role="button"
            aria-controls="contentIdsol_vant"
          >
            <p class="card-header-title">
              {{ $translate("sol_vant") }}
            </p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-up' : 'menu-down'"> </b-icon>
            </a>
          </div>
          <div class="card-content">
            <div class="content">
              <div class="columns">
                <div class="column">
                  <strong>{{ $translate("thick_pla") }}</strong>
                </div>
                <div class="column">
                  <b-input
                    type="number"
                    step="1"
                    v-model="order.footmeasurements.thick_plant_sx"
                    :disabled="disabledbool"
                    :placeholder="$translate('placeholder_numeric_mm')"
                  ></b-input>
                </div>
                <div class="column">
                  <strong>{{ $translate("thick_pla") }}</strong>
                </div>
                <div class="column">
                  <b-input
                    type="number"
                    step="1"
                    v-model="order.footmeasurements.thick_plant_dx"
                    :disabled="disabledbool"
                    :placeholder="$translate('placeholder_numeric_mm')"
                  ></b-input>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <strong>{{ $translate("thick_tacc") }}</strong>
                </div>
                <div class="column">
                  <b-input
                    type="number"
                    step="1"
                    v-model="order.footmeasurements.thick_tacc_sx"
                    :disabled="disabledbool"
                    :placeholder="$translate('placeholder_numeric_mm')"
                  ></b-input>
                </div>
                <div class="column">
                  <strong>{{ $translate("thick_tacc") }}</strong>
                </div>
                <div class="column">
                  <b-input
                    type="number"
                    step="1"
                    v-model="order.footmeasurements.thick_tacc_dx"
                    :disabled="disabledbool"
                    :placeholder="$translate('placeholder_numeric_mm')"
                  ></b-input>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>-->
      </div>
      <div class="column" />
    </div>
    <!-- fine sottopiede -->
    <b-field :label="$translate('note') | capitalize">
      <b-input v-model="order.note" type="textarea" name="note" :disabled="disabledbool" />
    </b-field>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/prod_details'

export default {
  name: 'ProdDetails',
  props: ['order', 'disabledbool', 'availablecont', 'availablesott', 'availablepunt', 'availablereinforcement'],
  inject: ['$validator'],
  data() {
    return {
      contrMatVarVisible: false,
      contrMatVars: [],
    }
  },
  computed: {
    contrSxPreview() {
      switch (this.order.typecontr_sx) {
        case 'calc':
          return require('@/assets/images/contrafforti/calcaneare_sx.png')
        case 'short':
          return require('@/assets/images/contrafforti/corto_sx.png')
        case 'pro_med':
          return require('@/assets/images/contrafforti/prolungato_mediale_sx.png')
        case 'pro_lat':
          return require('@/assets/images/contrafforti/prolungato_laterale_sx.png')
        case 'semi_bi':
          return require('@/assets/images/contrafforti/semirigido_sx.png')
        case 'medial':
          return require('@/assets/images/contrafforti/mediale_sx.png')
        case 'sidal':
          return require('@/assets/images/contrafforti/laterale_sx.png')
        case 'rig_bi':
          return require('@/assets/images/contrafforti/bilaterale_sx.png')
        case 'peronoic':
          return require('@/assets/images/contrafforti/peroneo_sx.png')
        case 'pro_bi':
          return require('@/assets/images/contrafforti/prolungato_bilaterale_sx.png')
        default:
          return 'https://via.placeholder.com/300'
      }
    },
    contrDxPreview() {
      switch (this.order.typecontr_dx) {
        case 'calc':
          return require('@/assets/images/contrafforti/calcaneare_dx.png')
        case 'short':
          return require('@/assets/images/contrafforti/corto_dx.png')
        case 'pro_med':
          return require('@/assets/images/contrafforti/prolungato_mediale_dx.png')
        case 'pro_lat':
          return require('@/assets/images/contrafforti/prolungato_laterale_dx.png')
        case 'semi_bi':
          return require('@/assets/images/contrafforti/semirigido_dx.png')
        case 'medial':
          return require('@/assets/images/contrafforti/mediale_dx.png')
        case 'sidal':
          return require('@/assets/images/contrafforti/laterale_dx.png')
        case 'rig_bi':
          return require('@/assets/images/contrafforti/bilaterale_dx.png')
        case 'peronoic':
          return require('@/assets/images/contrafforti/peroneo_dx.png')
        case 'pro_bi':
          return require('@/assets/images/contrafforti/prolungato_bilaterale_dx.png')
        default:
          return 'https://via.placeholder.com/300'
      }
    },
    contrType() {
      const types = ['Noone', 'calc', 'short', 'pro_med', 'pro_lat', 'pro_bi']
      const highTypes = ['semi_bi', 'medial', 'sidal', 'rig_bi', 'peronoic']
      return this.order.shoeType === 'high' ? [...types, ...highTypes] : types
    },
  },
  methods: {
    changeContrMaterialSx() {
      this.contrMatVarVisible = this.order['typecontr_sx'] && this.order['typecontr_sx' != 'Noone']
      this.contrMatVars = this.availablecont.find(m => m.id === this.order['tipocontr_dx']).variants
      this.order['tipocontr_var_sx'] = this.contrMatVars.length === 1 ? this.contrMatVars[0] : null
      //console.log(this.contrMatVarVisible)
      //console.log(this.contrMatVars)
      //console.log(this.order['tipocontr_var_sx'])
    },
    emitWarning(text) {
      this.$buefy.notification.open({
        duration: 10000,
        message: this.$translate(text),
        type: 'is-warning',
      })
    },
    warningSottopiedeRinforzo(side) {
      if (
        (side == 'dx' && this.order.tiporinfsott_dx == 'sottopiede4') ||
        (side == 'sx' && this.order.tiporinfsott_sx == 'sottopiede4')
      ) {
        this.emitWarning('warning_insert_zeppa_deambulante')
      }
    },
    copyLiningMeasurementsToRight() {
      if (this.order.masch_sx != undefined) {
        this.order.masch_dx = this.order.masch_sx
      }
      if (this.order.ling_sx != undefined) {
        this.order.ling_dx = this.order.ling_sx
      }
      if (this.order.mallmed_sx != undefined) {
        this.order.mallmed_dx = this.order.mallmed_sx
      }
      if (this.order.malllat_sx != undefined) {
        this.order.malllat_dx = this.order.malllat_sx
      }
      if (this.order.termtom_sx != undefined) {
        this.order.termtom_dx = this.order.termtom_sx
      }
      if (this.order.imb_gamb_sx != undefined) {
        this.order.imb_gamb_dx = this.order.imb_gamb_sx
      }
      this.$forceUpdate()
    },
    copyLiningMeasurementsToLeft() {
      if (this.order.masch_dx != undefined) {
        this.order.masch_sx = this.order.masch_dx
      }
      if (this.order.ling_dx != undefined) {
        this.order.ling_sx = this.order.ling_dx
      }
      if (this.order.mallmed_dx != undefined) {
        this.order.mallmed_sx = this.order.mallmed_dx
      }
      if (this.order.malllat_dx != undefined) {
        this.order.malllat_sx = this.order.malllat_dx
      }
      if (this.order.termtom_dx != undefined) {
        this.order.termtom_sx = this.order.termtom_dx
      }
      if (this.order.imb_gamb_dx != undefined) {
        this.order.imb_gamb_sx = this.order.imb_gamb_dx
      }
      this.$forceUpdate()
    },
    copypasdxinsx() {
      if (this.order.typecontr_dx != undefined) {
        this.order.typecontr_sx = this.order.typecontr_dx
      }
      if (this.order.tiporinfcontr_dx != undefined) {
        this.order.tiporinfcontr_sx = this.order.tiporinfcontr_dx
      }
      if (this.order.tipocontr_dx != undefined) {
        this.order.tipocontr_sx = this.order.tipocontr_dx
      }
      if (this.order.tipocontr_var_dx != undefined) {
        this.order.tipocontr_var_sx = this.order.tipocontr_var_dx
      }
      if (this.order.matrinfcontr_dx != undefined) {
        this.order.matrinfcontr_sx = this.order.matrinfcontr_dx
      }
      if (this.order.matrinfcontr_var_dx != undefined) {
        this.order.matrinfcontr_var_sx = this.order.matrinfcontr_var_dx
      }
      this.$forceUpdate()
    },
    copypassxindx() {
      if (this.order.typecontr_sx != undefined) {
        this.order.typecontr_dx = this.order.typecontr_sx
      }
      if (this.order.tiporinfcontr_sx != undefined) {
        this.order.tiporinfcontr_dx = this.order.tiporinfcontr_sx
      }
      if (this.order.tipocontr_sx != undefined) {
        this.order.tipocontr_dx = this.order.tipocontr_sx
      }
      if (this.order.tipocontr_var_sx != undefined) {
        this.order.tipocontr_var_dx = this.order.tipocontr_var_sx
      }
      if (this.order.matrinfcontr_sx != undefined) {
        this.order.matrinfcontr_dx = this.order.matrinfcontr_sx
      }
      if (this.order.matrinfcontr_var_sx != undefined) {
        this.order.matrinfcontr_var_dx = this.order.matrinfcontr_var_sx
      }
      this.$forceUpdate()
    },
    copysottopiededxinsx() {
      if (this.order.tiporinfsott_dx != undefined) {
        this.order.tiporinfsott_sx = this.order.tiporinfsott_dx
      }
      if (this.order.tiposott_dx != undefined) {
        this.order.tiposott_sx = this.order.tiposott_dx
      }
      if (this.order.tiposott_var_dx != undefined) {
        this.order.tiposott_var_sx = this.order.tiposott_var_dx
      }
      if (this.order.footmeasurements.thick_plant_dx != undefined) {
        this.order.footmeasurements.thick_plant_sx = this.order.footmeasurements.thick_plant_dx
      }
      if (this.order.footmeasurements.thick_tacc_dx != undefined) {
        this.order.footmeasurements.thick_tacc_sx = this.order.footmeasurements.thick_tacc_dx
      }
      this.$forceUpdate()
    },
    copysottopiedesxindx() {
      if (this.order.tiporinfsott_sx != undefined) {
        this.order.tiporinfsott_dx = this.order.tiporinfsott_sx
      }
      if (this.order.tiposott_sx != undefined) {
        this.order.tiposott_dx = this.order.tiposott_sx
      }
      if (this.order.tiposott_var_sx != undefined) {
        this.order.tiposott_var_dx = this.order.tiposott_var_sx
      }
      if (this.order.footmeasurements.thick_plant_sx != undefined) {
        this.order.footmeasurements.thick_plant_dx = this.order.footmeasurements.thick_plant_sx
      }
      if (this.order.footmeasurements.thick_tacc_sx != undefined) {
        this.order.footmeasurements.thick_tacc_dx = this.order.footmeasurements.thick_tacc_sx
      }
      this.$forceUpdate()
    },
    copypuntalidxinsx() {
      if (this.order.tipopunt_dx != undefined) {
        this.order.tipopunt_sx = this.order.tipopunt_dx
      }
      if (this.order.tipopunt_mat_dx != undefined) {
        this.order.tipopunt_mat_sx = this.order.tipopunt_mat_dx
      }
      if (this.order.tipopunt_mat_var_dx != undefined) {
        this.order.tipopunt_mat_var_sx = this.order.tipopunt_mat_var_dx
      }
      this.$forceUpdate()
    },
    copypuntalisxindx() {
      if (this.order.tipopunt_sx != undefined) {
        this.order.tipopunt_dx = this.order.tipopunt_sx
      }
      if (this.order.tipopunt_mat_sx != undefined) {
        this.order.tipopunt_mat_dx = this.order.tipopunt_mat_sx
      }
      if (this.order.tipopunt_mat_var_sx != undefined) {
        this.order.tipopunt_mat_var_dx = this.order.tipopunt_mat_var_sx
      }
      this.$forceUpdate()
    },
  },
}
</script>
<style scoped>
.container >>> td input {
  text-align: center;
}
.container >>> th input {
  text-align: center;
}
.preview {
  max-height: 300px;
  max-width: 300px;
  width: 300px;
}
</style>
